export default __webpack_public_path__ + "static/devfolio-5a0bed42d6ed104caa378d72f19229db.png";